class OzeaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.ozea-sticky-atc__button');
    this.realButton = document.querySelector('[id^="ProductSubmitButton-"]');

    if (!this.realButton) return;

    this.button.disabled = this.realButton.hasAttribute('disabled');
    this.button.addEventListener('click', () => this.realButton.click());

    this.mutationObserver = new MutationObserver(() => {
      this.button.disabled = this.realButton.hasAttribute('disabled');
    });
    this.mutationObserver.observe(this.realButton, { attributes: true, attributeFilter: ['disabled'] });

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const realButtonVisible = entries[0].isIntersecting;
        this.classList.toggle('is-visible', !realButtonVisible);
      },
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.realButton);
  }

  disconnectedCallback() {
    this.mutationObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  }
}

customElements.define('ozea-sticky-atc', OzeaStickyAtc);
